import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, withKeys as _withKeys, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "plan-content" }
const _hoisted_2 = {
  key: 1,
  id: "claim-search-form",
  class: "form claim-search align-items-end",
  method: "post"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" To view details for each Claim, click on the plus sign to the left of Claim #. If you wish to change the filter settings, click 'Change My Current Filters' button to return to the filter page. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Please note:"),
  /*#__PURE__*/_createTextVNode(" All claims paid/processed by ASO are here for information purposes and will reflect payments made. All supporting documents that accompanied the claim and the associated EOB’s are not imaged onto this site. Claims processed by the Fund Office on or after 1/1/2016 will provide a view of all attachments and the EOB for each claim.")
], -1)
const _hoisted_4 = { class: "custom-select links" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "body-text" }, " Patient Name ", -1)
const _hoisted_6 = { class: "custom-select links" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "body-text" }, " Claim Status ", -1)
const _hoisted_8 = { class: "action-buttons sm-pdr-0 sm-pdl-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alerts = _resolveComponent("Alerts")!
  const _component_MessageCard = _resolveComponent("MessageCard")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_CoveredCard = _resolveComponent("CoveredCard")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_PlanGeneral = _resolveComponent("PlanGeneral")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_DateInput = _resolveComponent("DateInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Alerts, {
      success: _ctx.success,
      errors: _ctx.errors
    }, null, 8, ["success", "errors"]),
    _createVNode(_component_MessageCard, {
      message: "Select parameters below to search for a specific claim or all claims for a specific date range.",
      type: "primary",
      iconClass: "iatse-icon-alarm",
      classes: "info_card_full"
    }),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
        : (_openBlock(), _createElementBlock("form", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_CoveredCard, {
              links: _ctx.links,
              small: true
            }, null, 8, ["links"]),
            _createVNode(_component_TextInput, {
              type: "text",
              name: "number",
              label: "Enter Claim",
              placeholder: "Enter here",
              max: 100,
              modelValue: _ctx.filters.Claim,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.Claim) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_TextInput, {
              type: "text",
              name: "number",
              label: "Enter Web Reference",
              placeholder: "Enter Web Reference",
              max: 25,
              modelValue: _ctx.filters.WebReference,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.WebReference) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_PlanGeneral, { text: "If you do not have a claim, use filters below to search for claim" }),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_Multiselect, {
                modelValue: _ctx.filters.PatientName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.PatientName) = $event)),
                options: _ctx.patients,
                placeholder: "Type to search",
                searchable: true,
                "close-on-select": true,
                label: "FullName",
                "track-by": "ID"
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_Multiselect, {
                modelValue: _ctx.filters.ClaimStatus,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.ClaimStatus) = $event)),
                options: _ctx.statuses,
                placeholder: "Type to search",
                searchable: true,
                "close-on-select": true,
                openDirection: "bottom"
              }, null, 8, ["modelValue", "options"])
            ]),
            _createVNode(_component_DateInput, {
              label: "Services date",
              modelValue: _ctx.filters.ServiceDate.StartDate,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.ServiceDate.StartDate) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_DateInput, {
              label: "",
              modelValue: _ctx.filters.ServiceDate.EndDate,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.ServiceDate.EndDate) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_DateInput, {
              label: "Submission Date",
              modelValue: _ctx.filters.SubmissionDate.StartDate,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters.SubmissionDate.StartDate) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_DateInput, {
              label: "",
              modelValue: _ctx.filters.SubmissionDate.EndDate,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters.SubmissionDate.EndDate) = $event))
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("a", {
                href: "",
                class: "btn btn-secondary plan-modal",
                onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["prevent"]))
              }, " Back "),
              _createElementVNode("button", {
                class: "btn btn-primary plan-modal",
                onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.searchData && _ctx.searchData(...args)), ["prevent"])),
                onKeypress: _cache[10] || (_cache[10] = _withKeys(
//@ts-ignore
(...args) => (_ctx.searchData && _ctx.searchData(...args)), ["enter"]))
              }, _toDisplayString(_ctx.loadingSearch ? 'Searching...' : 'Search'), 33)
            ])
          ]))
    ])
  ], 64))
}